import React from "react";
import InfoBox from '../components/info.js'
import Panoramic from "../components/panoramic.js";
import PhotoBas from './../../images/A3Bas_N024512-recadrage.jpg'

export default () => (
    <Panoramic>
        <div className='metadata--wrapper'>
            <img src={PhotoBas} alt="" />
            <InfoBox>La Capitale, croisement avec l&#39;autoroute Laurentienne. Photographe inconnu, Fonds W.B. Edwards inc, AVQ, 1973.</InfoBox>
        </div>
    </Panoramic>
);



// WEBPACK FOOTER //
// ./src/components/image-footer-axe3.js